<script>
import DataLabel from '@/js/components/common/labels/DataLabel';

export default {
    name: 'WorkflowLabel',

    functional: true,

    props: {
        workflow: {type: Object, default: null},
        hideIcon: {type: Boolean},
        largeIcon: {type: Boolean},
        showLink: {type: Boolean},
    },

    render(createElement, {props, data, parent}) {
        let href = null;

        if (props.workflow && props.showLink) {
            const gate = parent.$gate;

            if (gate.allow('read', 'workflow', props.workflow)) {
                const router = parent.$toRoute;

                href = router('workflows.show', {workflow: props.workflow}).toString();
            }
        }

        const iconClass = 'fa fa-fw fa-project-diagram' + (props.largeIcon ? ' fa-lg' : '');

        data.props = {
            item: props.workflow,
            hideIcon: props.hideIcon,
            iconClass: iconClass,
            none: parent.$t('workflows.nil'),
            href: href,
        };

        return createElement(DataLabel, data);
    },
};
</script>
